<template>
  <v-app>

    <Header />
  
    <v-content>
      <router-view/>
    </v-content>

    <Footer />

  </v-app>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
export default {
    name: 'App',
    components: {
        Header,
        Footer
    }
};
</script>

<style lang="scss">
@media (min-width: 1904px) {
  .container {
      max-width: 1264px;
  }
}
.v-application {
    font-family: 'Overpass', sans-serif;
    p {
      margin-bottom: 5px
    }
    .v-card__text a {
      color: #fff;
      font-weight: bold;
      &:hover {
        text-decoration: none
      }
    }
    header a {
      font-weight: bold;
    }
}
.text-shadow-black {
    text-shadow: 1px 1px #000;
}
.text-shadow-white {
    text-shadow: 0px 0px 1px #fff;
}
.container {
  padding-top: 0;
  padding-bottom: 0;
}
.text-hide {
    font: 0/0 a;
    color: transparent;
    text-shadow: none;
    background-color: transparent;
    border: 0;
}
</style>